import axios from 'axios';
import { createActionType } from 'utils/redux';
import qs from 'qs';
import {
  apiDashboardStats,
  apiDashboardTopLeads,
} from 'constants/apiRouting';
import { handleErrors } from '../../utils/api';


export const RESET_DASHBOARD = 'RESET_DASHBOARD';
export const UPDATE_DASHBOARD_PARAMS = 'UPDATE_DASHBOARD_PARAMS';
export const GET_DASHBOARD_STATS = createActionType('GET_DASHBOARD_STATS');
export const GET_TOP_LEADS = createActionType('GET_TOP_LEADS');

export const resetDashboard = () => async (dispatch) => {
  dispatch({
    type: RESET_DASHBOARD,
    payload: {},
  });
};

export const loadDashboardStats = params => dispatch => dispatch({
  type: GET_DASHBOARD_STATS.name,
  payload: axios.get(apiDashboardStats(), {
    params,
    withCredentials: true,
    paramsSerializer: p => qs.stringify(p),
  }),
})
  // eslint-disable-next-line
  .catch((error) => {
    handleErrors(error, dispatch);
  });

export const updateDashboardParams = params => dispatch => dispatch({
  type: UPDATE_DASHBOARD_PARAMS,
  payload: params,
});

export const loadTopLeads = params => dispatch => dispatch({
  type: GET_TOP_LEADS.name,
  payload: axios.get(apiDashboardTopLeads(), {
    params,
    withCredentials: true,
    paramsSerializer: p => qs.stringify(p),
  }),
})
  .catch((error) => {
    handleErrors(error, dispatch);
  });
